module.exports = __webpack_public_path__ + "img/Steering_wheel.f2e2a9c5.svg";